import { useState, Fragment, useEffect, useRef, forwardRef } from 'react'
import AddressFormComponent from '../../elements/address-lookup'

const AddressHistory = forwardRef(
  (
    { lookup, label, name, minimumRequiredYears = 3, onChange = () => {}, error, formVariant },
    ref,
  ) => {
    const [addresses, setAddresses] = useState([{}])
    const [currentYears, setCurrentYears] = useState(0)
    const [lastChanged, setLastChanged] = useState(0)

    const handleAddressChange = (key, address) => {
      setAddresses(currAddresses =>
        currAddresses.map((addr, index) => {
          if (key === index) {
            if (addr.yearsAtAddress !== address.yearsAtAddress) {
              setLastChanged(key)
            }

            return address
          } else {
            return addr
          }
        }),
      )
    }

    useEffect(() => {
      onChange(addresses)
      setCurrentYears(
        addresses.reduce((prev, addr) => prev + parseInt(addr.yearsAtAddress || 0), 0),
      )
    }, [addresses])

    const firstUpdate = useRef(true)
    useEffect(() => {
      if (firstUpdate.current) {
        firstUpdate.current = false
        return
      }
      if (lastChanged === addresses.length - 1 && currentYears < minimumRequiredYears) {
        setAddresses(prevAddrs => [...prevAddrs, {}])
      } else if (currentYears >= minimumRequiredYears) {
        setAddresses(prevAddrs => prevAddrs.slice(0, lastChanged + 1))
      }
    }, [currentYears])

    return (
      <Fragment>
        <input
          type='hidden'
          id='addressData'
          name={name}
          ref={ref}
          value={JSON.stringify(addresses)}
        />
        {addresses.map((_, index) => (
          <AddressFormComponent
            key={index}
            label={label}
            id={index}
            lookup={lookup}
            onChange={handleAddressChange}
            error={error}
            formVariant={formVariant}
            hasTimeAtAddress={true}
          />
        ))}
      </Fragment>
    )
  },
)

export default AddressHistory
